import { useEffect, useState } from 'react'
import axios from 'axios'
import { Pagination } from 'antd'
import AlmamaterVisitDynamicRibbon from './ribbon'
import AlmamaterVisitDynamicDetail from './detail'
import DeleteAlmamaterVisitDynamic from './delete'
import MyIcon from '../../../components/general/icon'

export default function AlmamaterVisitDynamic() {
  const merchantOid = localStorage.getItem('merchant_oid')
  const [currentPage, setCurrentPage] = useState(1)
  const [propsData, setPropsData] = useState({})
  const [dynamicData, setDynamicData] = useState({})
  const [isDetailVisible, setIsDetailVisible] = useState(false)
  const [isDeleteVisible, setIsDeleteVisible] = useState(false)

  const initialConditions = {
      status: ''
    }
    const [filterValue, setFilterValue] = useState(initialConditions)

  const getAlmamaterVisitDynamicData = () => {
    axios.post('/p/almamater_visit/dynamic/list/get', { 
      merchant_oid: merchantOid,
      status: filterValue.status,
      page: currentPage, 
      per_page: 20
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setDynamicData({
            'total_page': response.data.total_page,
            'current_page': response.data.current_page,
            'total': response.data.total,
            'dynamics': response.data.dynamics
          })
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  useEffect(() => {
    getAlmamaterVisitDynamicData()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [merchantOid, currentPage, filterValue])

  const getColor = (key) => {
    if (key === 2) return 'green'
    if (key === 3) return 'red'
    return 'black'
  }

  const previewDetail = (oid) => {
    setIsDetailVisible(true)
    setPropsData({ oid: oid})
  }

  const deleteDynamic = (oid, name) => {
    setIsDeleteVisible(true)
    setPropsData({ oid: oid, name: name})
  }

  return (
    <div className="public-page">
      <div className="public-container">
        <div className="public-header">
          <div className="public-title">动态审核</div>
          <AlmamaterVisitDynamicRibbon 
            filterValue={filterValue} 
            setFilterValue={setFilterValue}
          />
        </div>

        <div className='public-main-style2'>
          <table className='public-main-style2-item'>
            <thead>
              <tr className='public-main-style2-thead'>
                <th style={{textAlign: 'left', paddingLeft: '20px'}}>打卡人</th>
                <th>打卡团队</th>
                <th>打卡行程</th>
                <th>照片数量</th>
                <th>审核状态</th>
                <th>打卡时间</th>
                <th>点赞数</th>
                <th style={{width: '50px'}}></th>
              </tr>
            </thead>

            <tbody>
              {dynamicData.dynamics && (dynamicData.dynamics.length > 0 ? (dynamicData.dynamics.map((item) => (
                <tr className='public-main-style2-tbody' key={item.oid} onClick={() => { previewDetail(item.oid) }}>
                  <td style={{textAlign: 'left', paddingLeft: '20px'}}>{item.name}</td>
                  <td>{item.team_name}</td>
                  <td>{item.itinerary_name}</td>
                  <td>{item.photo_count}</td>
                  <td style={{ color: getColor(item.status.key) }}>{item.status.value}</td>
                  <td>{item.create_time}</td>
                  <td>{item.like_count}</td>
                  <td style={{width: '50px'}}>
                    <div className='public-main-style2-operation-box'>
                      <div className='public-main-style2-operation' 
                        onClick={(event) => {event.stopPropagation(); deleteDynamic(item.oid, item.name)}}>
                        <MyIcon name='huishouzhan' />
                      </div>
                    </div>
                  </td>
                </tr>
              ))) : (
                <tr className='public-main-style2-tbodyEmpty'>
                  <td colSpan="5"><span>暂无数据</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className='pagination'>
          <Pagination 
            current={currentPage}
            total={dynamicData.total}
            pageSize={20}
            onChange={(page) => setCurrentPage(page)}
            showTotal={(total) => `共${total}条`}
            showSizeChanger={false}
            hideOnSinglePage={true}
            showQuickJumper={true}
          />
        </div>

        {isDetailVisible && <AlmamaterVisitDynamicDetail
          data={propsData}
          isOpen={isDetailVisible}
          getAlmamaterVisitDynamicData={getAlmamaterVisitDynamicData}
          isCancel={() => { setIsDetailVisible(false) }}
        />}

        {isDeleteVisible && <DeleteAlmamaterVisitDynamic
          data={propsData}
          getAlmamaterVisitDynamicData={getAlmamaterVisitDynamicData} 
          isOpen={isDeleteVisible} 
          isCancel={() => { setIsDeleteVisible(false) }} 
        />}
      </div>
    </div>
  )
}
